import { loc } from "../../../core/utils"
import Order from "./Order"
import SelectField from "./SelectField"
import useOrderListing from "./useOrderListing"
import React from "react"
import { Col, Container, Row, Spinner } from "react-bootstrap"
import * as FinalForm from "react-final-form"

const OrderListing = ({ orders, isLoadingOrders, handleFilters }) => {
  const { statusOPL, sortsFilter, formatDate, formatStatus } = useOrderListing()

  const onSubmit = (values) => {
    handleFilters(values)
  }

  if (!orders && !isLoadingOrders)
    return (
      <Container className="d-flex justify-content-center">
        <span>{loc("start_by_searching_for")}</span>
      </Container>
    )

  return (
    <FinalForm.Form
      initialValues={{
        sortBy: sortsFilter[0],
        oplStatus: statusOPL[0]
      }}
      keepDirtyOnReinitialize
      onSubmit={onSubmit}
      render={({ handleSubmit }) => {
        return (
          <Container>
            <Row>
              <Col sm={12} lg={5}></Col>
              <Col xs={12} sm={4} lg={3}>
                <SelectField name="sortBy" label={loc("sort_by")} options={sortsFilter} onChange={handleSubmit} />
              </Col>
              <Col xs={12} sm={8} lg={4}>
                <SelectField name="oplStatus" label={loc("filter_by")} options={statusOPL} onChange={handleSubmit} />
              </Col>
            </Row>

            {isLoadingOrders && (
              <Container className="d-flex flex-column align-items-center justify-content-center">
                <Spinner className="m-5 spinner" animation="border" />
                <span>{loc("loading_orders")}</span>
              </Container>
            )}

            {!isLoadingOrders && orders && orders.length > 0 && (
              <Row>
                <Col>
                  {orders.map((order) => (
                    <Order
                      key={order.opl}
                      firstname={order.firstname}
                      lastname={order.lastname}
                      product={order.product}
                      opl={order.opl}
                      date={formatDate(order.date)}
                      status={formatStatus(order.status)}
                      redirectionUrl={order.redirectionUrl}
                      shippingDate={order.shippingDate}
                      deliveryMethod={order.deliveryMethod}
                      orderLanguageTag={order.orderLanguageTag}
                    />
                  ))}
                </Col>
              </Row>
            )}

            {!isLoadingOrders && orders && orders.length === 0 && (
              <Container className="d-flex justify-content-center">
                <span>{loc("search_no_result")}</span>
              </Container>
            )}
          </Container>
        )
      }}
    />
  )
}

export default OrderListing
